<template>
  <div>
    <ul
      v-if="content.items"
      :class="{ 'flex flex-wrap mx-auto max-w-screen-xl': content.layout === 'free_fluid' }"
    >
      <CalloutContent
        :class="{
          'sm:w-1/2 lg:w-1/4': content.layout === 'free_fluid' && content.items.length % 2 === 0,
          'sm:w-1/2 md:w-1/3': content.layout === 'free_fluid' && content.items.length % 2 !== 0,
        }"
        v-for="(item, index) in content.items"
        :content="item"
        :key="index"
      />
    </ul>
  </div>
</template>

<script lang="ts" setup>
import type { GQLCalloutSlice } from './generated/callout'
import CalloutContent from './callout-content.vue'
defineProps<{ content: GQLCalloutSlice }>()
</script>
